module.exports = __webpack_public_path__ + "static/media/zodiac-Aquarius.035b832c.png";